// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__ApDRo","inputDescription":"styles_inputDescription__1tm43"};